export const SET_LOADED = 'reports/SET_LOADED';
export const SET_SCHEDULED = 'reports/SET_SCHEDULED';
export const ADD_MANUAL_REPORT = 'ADD_MANUAL_REPORT';
export const ADD_AUTO_REPORT = 'ADD_AUTO_REPORT';
export const EDIT_AUTO_REPORT = 'EDIT_AUTO_REPORT';
export const UPDATE_REPORT_PROGRESS = 'reports/UPDATE_REPORT_PROGRESS';
export const DELETE_REPORT = 'reports/DELETE_REPORT';
